"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var React = require('react');
var ReactDOM = require('react-dom');
var async = require('async');
var _require = require('react-intl'),
  FormattedMessage = _require.FormattedMessage,
  injectIntl = _require.injectIntl;
var _require2 = require("../inputs/data/cloudinary-data"),
  getCloudinaryTextData = _require2.getCloudinaryTextData;

//.input-error class is what we will toggle
var AddProfilePic = /*#__PURE__*/function (_React$Component) {
  _inherits(AddProfilePic, _React$Component);
  function AddProfilePic(props) {
    var _this;
    _classCallCheck(this, AddProfilePic);
    _this = _callSuper(this, AddProfilePic, [props]);
    _this.state = {
      photoError: "",
      widget: null
    };
    _this.onTransactableProfilePicUpload = _this.onTransactableProfilePicUpload.bind(_assertThisInitialized(_this));
    _this.renderCloudinaryWidget = _this.renderCloudinaryWidget.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(AddProfilePic, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var locale = this.props.intl.locale;
      var profilePhotoPresets = {
        upload_preset: 'e6m9x7iz',
        show_powered_by: false,
        multiple: false,
        cropping: 'server',
        cropping_aspect_ratio: 1,
        mode: 'crop',
        gravity: 'custom',
        client_allowed_formats: ["jpg", "jpeg", "png"],
        sources: ['local'],
        theme: 'white',
        max_file_size: 8000000,
        max_image_width: 1000,
        max_image_height: 1000,
        showSkipCropButton: false,
        language: locale,
        text: _defineProperty({}, locale, getCloudinaryTextData(this.props.intl))
      };
      cloudinary.setCloudName('peerspace-inc');
      var widget = cloudinary.createUploadWidget(profilePhotoPresets, function (error, result) {
        this.onTransactableProfilePicUpload(error, result);
      }.bind(this));
      this.setState({
        widget: widget
      });
    }
  }, {
    key: "onTransactableProfilePicUpload",
    value: function onTransactableProfilePicUpload(err, result) {
      if (err) {
        this.setState({
          photoError: 'Something went wrong.  Please try again.'
        });
      } else if ('success' === result.event) {
        var imgInfo = (result || {}).info || {};
        var newProfileURL = imgInfo.secure_url;
        var croppedProfileURL = newProfileURL.replace("upload/", "upload/c_crop,g_custom/");
        var user = {};
        user.avatar_url = croppedProfileURL;
        var usrStr = JSON.stringify(user);
        this.props.updateAction(this.props.user.SSOid, usrStr, this.props.callback);
      }
    }
  }, {
    key: "renderCloudinaryWidget",
    value: function renderCloudinaryWidget(event) {
      event.preventDefault();
      this.state.widget.open();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        id: "add-photo"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "shared_components.profile_pic.upload_your_photo",
        defaultMessage: "Upload Your Profile Photo"
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        id: "profile-photo-area",
        className: "col-sm-3 col-sm-offset-2"
      }, /*#__PURE__*/React.createElement("div", {
        id: "upload-photo-icon",
        onClick: this.renderCloudinaryWidget,
        className: "text-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ico ico-lg icon-user"
      })), /*#__PURE__*/React.createElement("div", {
        id: "profile-photo-display"
      }), /*#__PURE__*/React.createElement("div", {
        id: "photo-error",
        className: "text-center text-primary"
      }, this.state.photoError)), /*#__PURE__*/React.createElement("div", {
        id: "profile-photo-button",
        className: "col-sm-6 text-xs-center text-sm-justify"
      }, /*#__PURE__*/React.createElement("button", {
        "tab-index": "1",
        onClick: this.renderCloudinaryWidget,
        className: "btn btn-md inverted-button-success btn-black"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ico icon-add-photos"
      }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "shared_components.profile_pic.upload_photo",
        defaultMessage: "Upload Photo"
      }))))));
    }
  }]);
  return AddProfilePic;
}(React.Component);
AddProfilePic.propTypes = {
  intl: _propTypes.default.object
};
module.exports = injectIntl(AddProfilePic);